import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { environmentAtom } from "../../store";

export const useEnvironment = () => useAtom(environmentAtom);

export const useEnvironmentValues = () => useAtomValue(environmentAtom);

export const useSetEnvironmentValues = () => useSetAtom(environmentAtom);
